export default __webpack_public_path__ + "static/media/icons-category-pints.196bd9a9.svg";